import React, { CSSProperties, useEffect, useState } from "react";

import { Container } from "./styles";

interface Props {
	buttonText?: string;
	linkTo?: string;
	onClick?: () => void;
	style?: CSSProperties;
}

const ButtonOpenAccount: React.FC<Props> = ({
	buttonText = "Criar Conta",
	linkTo = "/create-account-wallet",
	onClick,
	style,
}) => {
	const [currentLink, setCurrentLink] = useState(linkTo);

	useEffect(() => {
		const updateLinkForMobile = () => {
			if (window.matchMedia("(max-width: 720px)").matches) {
				setCurrentLink("/signin");
			} else {
				setCurrentLink(linkTo);
			}
		};

		updateLinkForMobile(); // Atualiza o link ao carregar a página
		window.addEventListener("resize", updateLinkForMobile); // Atualiza o link ao redimensionar a janela

		return () => {
			window.removeEventListener("resize", updateLinkForMobile);
		};
	}, [linkTo]);

	const handleClick = () => {
		if (onClick) {
			onClick();
		}
	};

	return (
		<>
			<Container
				className="rounded-lg lg:rounded-2xl 2xl:rounded-3xl"
				href={currentLink}
				onClick={handleClick}
				style={style}
			>
				<span className="font-asap font-bold">{buttonText}</span>
			</Container>
		</>
	);
};

export default ButtonOpenAccount;
